module.exports = __webpack_public_path__ + "img/keder_gruen_candy.169f7a74.jpg";